import { React, PT, connect } from '@gasbuddy/react';
import { CSVLink } from 'react-csv';
import { Table, Dimmer, Loader, Segment, Grid, Dropdown, Icon, Button, Confirm } from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Auth, Nav, Pagination } from '../../components';
import { Action } from '../../reducers';

const csvHeaders = ['Date', 'Type', 'Amount', 'Status'];

function csvRow(r) {
  return [
    moment(r.created).toISOString(),
    (r.meta && r.meta.transactionId) ? 'customer' : 'wex',
    r.amount,
    r.status,
  ];
}

class DwollaBase extends React.Component {
  componentDidMount() {
    const { dwolla, dispatch } = this.props;
    this.fetchRows(dwolla);
    dispatch({
      type: Action.Payment.Dwolla.BalanceRequested,
      meta: { apiAction: true },
      payload: {
        url: '/payments/dwolla/status',
      },
    });
  }

  async setPageSize(n) {
    const { dwolla, dispatch } = this.props;
    await dispatch({
      type: Action.Payment.Dwolla.SetPageSize,
      payload: n,
    });
    this.fetchRows(dwolla);
  }

  setPage(n) {
    const { dwolla } = this.props;
    const offset = dwolla.limit * n;
    this.fetchRows({
      ...dwolla,
      offset,
    });
  }

  setDate(d) {
    const { dwolla } = this.props;
    this.fetchRows({
      ...dwolla,
      end: d.valueOf(),
    });
  }

  setTxType(data) {
    const { value = 'all' } = data;
    const { dwolla } = this.props;
    const opts = { ...dwolla };
    if (value === 'all') {
      delete opts.type;
    } else {
      opts.type = value;
    }
    this.fetchRows(opts);
  }

  cancelTransfer = () => {
    const { dwolla, dispatch } = this.props;
    const toCancel = dwolla.cancelCandidate;
    dispatch({
      type: Action.Payment.Dwolla.CancelRequested,
      meta: { apiAction: true },
      payload: {
        url: '/payments/dwolla/cancel',
        body: {
          id: toCancel.id,
        },
      },
    });
  }

  createRow(r) {
    let type = r.counterparty;
    const { dispatch } = this.props;
    if (r.meta && r.meta.transactionId) {
      if (r.transaction_id) {
        type = (
          <span>
Customer Purchase
            <a href={`/identity/users/${r.account_id}`}>{r.email}</a>
            {r.batch && (
            <span>
&nbsp;Batch
              {r.batch}
&nbsp;
            </span>
            )}
            &nbsp;&nbsp;(
            <a href={`/payments/transaction/${r.account_id}/${r.transaction_id}`}>view transaction</a>
)
            {r.status === 'pending' && (
            <Auth forRoles="admin.superuser" hideUnauthorized>
              <span>
&nbsp;&nbsp;
                <Button
                  onClick={() => dispatch({
                    type: Action.Payment.Dwolla.CancelConfirmationRequested,
                    payload: r,
                  })}
                >
                  Cancel Transfer
                </Button>
              </span>
            </Auth>
            )}
          </span>
        );
      } else {
        type = 'Customer Purchase';
      }
    } else if (r.meta && r.meta.batch) {
      type = `Wex Payment for batch ${r.meta.batch} (${moment(r.meta.batch, 'YYYYMMDD').format('MMM DD')})`;
    }
    const txd = moment(r.created);
    return (
      <Table.Row negative={r.amount < 0} key={r.id}>
        <Table.Cell>{txd.format('MMM DD')}</Table.Cell>
        <Table.Cell textAlign="center">{txd.format('HH:mm')}</Table.Cell>
        <Table.Cell colSpan="2">{type}</Table.Cell>
        <Table.Cell textAlign="center">{r.status}</Table.Cell>
        <Table.Cell textAlign="right">
$
          {r.amount}
        </Table.Cell>
      </Table.Row>
    );
  }

  fetchRows(opts) {
    const offset = opts.offset || 0;
    let url = `/payments/dwolla/transactions?limit=${opts.limit}&offset=${offset}`;
    if (opts.type && opts.type !== 'all') {
      url = `${url}&recipient_name=${opts.type}`;
    }
    if (opts.end) {
      url = `${url}&end_date=${moment(opts.end).toISOString()}`;
    }
    const { dispatch } = this.props;
    dispatch({
      type: Action.Payment.Dwolla.LoadRequested,
      meta: { apiAction: true },
      payload: {
        url,
        query: opts,
      },
    });
  }

  render() {
    const { dwolla: { loading, txs = [], limit, offset, total, end, balance, canceling, cancelCandidate, type = 'all' }, dispatch } = this.props;
    const options = [
      { key: 'all-tx', value: 'all', text: 'All transactions' },
      { key: 'wex-tx', value: 'wex', text: 'Wex transactions' },
    ];
    const selectedType = type === 'wex' ? options[1] : options[0];

    return (
      <Auth forRoles="admin.superuser,admin.payment.dwolla">
        <Nav>
          <h1>Dwolla Transactions</h1>

          <Confirm
            open={!!cancelCandidate}
            content={`Are you sure you want to cancel the transfer of $${cancelCandidate ? cancelCandidate.amount : 0}?`}
            onCancel={() => dispatch({ type: Action.Payment.Dwolla.CancelCancel })}
            onConfirm={() => this.cancelTransfer()}
          />

          <Dimmer.Dimmable as={Segment} dimmed={loading || canceling}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>

            <Segment>
              <Grid columns="equal">
                <Grid.Column>
                  <Dropdown
                    inline
                    options={options}
                    defaultValue={selectedType.value}
                    text={selectedType.text}
                    onChange={(e, d) => this.setTxType(d)}
                  />
                  &nbsp; starting from &nbsp;
                  <DatePicker
                    selected={moment(end)}
                    className="datetime"
                    onChange={d => this.setDate(d)}
                  />
                </Grid.Column>

                {balance
                  && (
                  <Grid.Column textAlign="right">
                    Balance: $
                    {balance.value}
                    {' '}
&nbsp;
                    <CSVLink data={txs.map(csvRow)} headers={csvHeaders} filename={`gb-dwolla-${moment(end).format('YYYY-MM-DD')}.csv`}>
                      <Icon name="file excel outline" />
                    </CSVLink>
                  </Grid.Column>
                  )
                }
              </Grid>
            </Segment>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={1}>Date</Table.HeaderCell>
                  <Table.HeaderCell width={1}>Time</Table.HeaderCell>
                  <Table.HeaderCell colSpan="2">Transaction Type</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" width={2}>Status</Table.HeaderCell>
                  <Table.HeaderCell width={3}>Amount</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {txs.map(r => this.createRow(r))}
              </Table.Body>

              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    <Dropdown
                      simple
                      item
                      text={limit}
                      defaultValue={limit}
                      onChange={(event, { value }) => this.setPageSize(value)}
                      options={[
                        { key: 1, text: '10', value: 10 },
                        { key: 2, text: '25', value: 25 },
                        { key: 3, text: '50', value: 50 },
                      ]}
                    />
                    &nbsp; transactions per page &nbsp;
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan="2" textAlign="center">
                    {total}
                    {' '}
Transactions
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan="2">
                    <Pagination
                      total={total}
                      pageSize={limit}
                      offset={offset}
                      onPageSelected={n => this.setPage(n)}
                      floated="right"
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </Dimmer.Dimmable>

        </Nav>
      </Auth>
    );
  }
}

DwollaBase.propTypes = {
  dwolla: PT.shape({
    loading: PT.bool,
    limit: PT.number,
    offset: PT.number,
    balance: PT.string,
    end: PT.number,
    type: PT.string,
    txs: PT.arrayOf(PT.shape({
      counterparty: PT.string.isRequired,
    })),
    total: PT.number,
    cancelCandidate: PT.object,
    canceling: PT.bool,
  }).isRequired,
  dispatch: PT.func.isRequired,
};

export const Dwolla = connect(({ dwolla }) => ({ dwolla }))(DwollaBase);
